import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import Container from "../../../modules/commons/Container";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import { mapToObjectDDL, removeNullFields } from "../../common/mapper";
import MasterHargaJasaSearch from "./components/masterHargaJasaSearch";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import {
  INITIAL_DATE,
  INITIAL_FILTER_VALUE,
  INITIAL_PAGINATION,
  tableConfig,
} from "./config";
import MasterHargaJasaDetail from "./components/masterHargaJasaDetail";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import MasterHargaJasaFilter from "./components/masterHargaJasaFilter";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import { ACTIVITY_TYPE, HttpStatus } from "../../common/Constants";

class MasterHargaJasa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      selectedCabang: null,
      loading: false,
      search: {
        startTanggalBerlaku: INITIAL_DATE,
        endTanggalBerlaku: INITIAL_DATE,
      },
      filterVisibility: false,
      userAccess: null,
      pagination: INITIAL_PAGINATION,
      alertInfo: {
        visible: false,
        title: null,
        content: null,
        action: null,
        data: null,
      },
      detail: {
        visible: false,
        selectedId: null,
        activityType: null,
      },
      skipNextFetch: false,
      submitedFilter: INITIAL_FILTER_VALUE,
      uploadVisible: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevState.selectedCabang?.value;
    const currCabang = this.state.selectedCabang?.value;
    if (prevCabang !== currCabang) {
      this.setState((prev) => ({
        ...prev,
        pagination: INITIAL_PAGINATION,
        skipNextFetch: true,
        search: {
          startTanggalBerlaku: INITIAL_DATE,
          endTanggalBerlaku: INITIAL_DATE,
        },
      }));
      this.fetchData(
        {
          startTanggalBerlaku: INITIAL_DATE,
          endTanggalBerlaku: INITIAL_DATE,
        },
        5,
        1
      );
    }
    const prevPagination = prevState.pagination;
    const currPagination = this.state.pagination;

    if (
      (prevPagination.limit !== currPagination.limit ||
        prevPagination.page !== currPagination.page) &&
      !this.state.skipNextFetch
    ) {
      this.fetchData(
        {
          ...removeNullFields(this.state.submitedFilter),
        },
        currPagination.limit,
        currPagination.page
      );
    }
    if (this.state.skipNextFetch) {
      this.setState({ skipNextFetch: false });
    }
  }

  loadInitialData = async () => {
    this.fetchData(
      {
        startTanggalBerlaku: moment().format("DD-MM-YYYY"),
        endTanggalBerlaku: moment().format("DD-MM-YYYY"),
        kodeCabang: this.state.selectedCabang?.value,
      },
      5,
      1
    );
  };

  fetchData = async (filter = {}, limit, page) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMainPageMasterHargaJasa,
      menuName: "Master Harga Jasa",
      setError: this.props.setError,
      args: {
        ...filter,
        limit: limit || this.state.pagination.limit,
        page: page || this.state.pagination.page,
        kodeCabang: this.state.selectedCabang?.value,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName: "Master Mekanik",
      args: null,
    });
    if (res.ok) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          selectedCabang: mapToObjectDDL(
            filteredData[0].namaDealer,
            filteredData[0].kodeCabang
          ),
          userAccess: getUserAccess(
            this.props.menuAccess,
            filteredData[0].kodeCabang
          ),
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleRefresh = async (paylod) => {
    this.setState((prev) => ({
      ...prev,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: true,
      search: {
        startTanggalBerlaku: INITIAL_DATE,
        endTanggalBerlaku: INITIAL_DATE,
      },
    }));
    await this.fetchData(
      {
        startTanggalBerlaku: INITIAL_DATE,
        endTanggalBerlaku: INITIAL_DATE,
      },
      5,
      1
    );
  };

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  handlePeriodChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleSearch = async (payload) => {
    this.setState((prev) => ({
      ...prev,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: true,
      search: payload,
      submitedFilter: {
        ...prev.submitedFilter,
        ...payload,
      },
    }));
    this.fetchData(payload, 5, 1);
  };

  handleFilterVisibility = () => {
    this.setState((prev) => ({
      ...prev,
      filterVisibility: !prev.filterVisibility,
    }));
  };

  handleConfirmDelete = async (id) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").updateStatusMasterHargaJasa,
      menuName: "Master Harga Jasa",
      setError: this.props.setError,
      args: {
        servicePriceId: id,
        status: "INACTIVE",
      },
    });
    this.handleTriggerLoading();
    this.handleAlertInfoVisibility();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
      this.handleAlertInfoVisibility("Informasi", "Data Berhasil Dihapus");
    }
  };

  handleDelete = async (id) => {
    this.handleAlertInfoVisibility(
      "Pertanyaan",
      "Apakah anda yakin ingin menghapus data ini?",
      "delete",
      id
    );
  };

  handleDetailVisibility = (value, activityType) => {
    this.setState((prev) => ({
      ...prev,
      detail: {
        ...prev.detail,
        visible: !prev.detail?.visible,
        selectedId: value,
        activityType: activityType,
      },
    }));
  };

  getTableColumns = () => {
    return tableConfig({
      dataTable: this.state.dataTable,
      handleDelete: this.handleDelete,
      toggleEdit: this.handleDetailVisibility,
      userAccess: this.state.userAccess,
    });
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleAlertInfoVisibility = (title, content, action, data) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        action: action,
        data: data,
      },
    }));
  };

  handleAccept = () => {
    const { alertInfo } = this.state;
    if (alertInfo.action === "submit") {
      this.handleConfirmSubmit(alertInfo.data);
    }
    if (alertInfo.action === "delete") {
      this.handleConfirmDelete(alertInfo.data);
    }
  };

  handleConfirmSubmit = async (payload) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterHargaJasa,
      menuName: "Master Harga Jasa",
      setError: this.props.setError,
      args: payload,
    });
    this.handleTriggerLoading();
    this.handleAlertInfoVisibility();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleRefresh();
      this.handleDetailVisibility();
      this.handleAlertInfoVisibility("Informasi", "Data Berhasil Disimpan");
    }
  };

  handleSubmitFilter = (value) => {
    const payload = removeNullFields(value);
    this.setState((prev) => ({
      ...prev,
      submitedFilter: payload,
      pagination: INITIAL_PAGINATION,
      skipNextFetch: true,
      search: {
        startTanggalBerlaku: null,
        endTanggalBerlaku: null,
      },
    }));
    this.fetchData({ ...payload }, 5, 1);
  };

  handleUploadVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      uploadVisible: !prevValue.uploadVisible,
    }));
  };

  render() {
    const {
      dataCabang,
      selectedCabang,
      loading,
      search,
      pagination,
      detail,
      filterVisibility,
      alertInfo,
      dataTable,
      submitedFilter,
      userAccess,
    } = this.state;
    return (
      <Container>
        <FlexView vAlignContent="center" style={{ gap: "10px" }}>
          <p className="margin margin-bottom-15px">Cabang</p>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="selectedCabang"
            containerclassname="width width-280px"
            placeholder="Nama cabang hak akses"
            options={dataCabang}
            value={selectedCabang}
            onChange={(value, { name }) => this.handleValueChange(name, value)}
          />
        </FlexView>
        <MasterHargaJasaSearch
          {...search}
          onPeriodeChange={this.handlePeriodChange}
          onSearch={this.handleSearch}
          handleFilterVisibility={this.handleFilterVisibility}
        />
        <SimpleDataTable
          columns={this.getTableColumns()}
          data={dataTable}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={defaultTableChange(
            this.handleChangePage,
            this.handleRowsPerPage
          )}
          footerAdditionalButtons={
            <SimpleButton
              type="button"
              text="Tambah"
              secondary={!userAccess?.createAccess}
              disabled={!userAccess?.createAccess}
              icon={<i className="fa fa-plus margin margin-right-5px" />}
              onClick={() =>
                this.handleDetailVisibility(null, ACTIVITY_TYPE.CREATE)
              }
            />
          }
        />
        {detail.visible && (
          <MasterHargaJasaDetail
            {...this.props}
            dataCabang={dataCabang}
            visible={detail.visible}
            selectedId={detail.selectedId}
            activityType={detail.activityType}
            selectedCabang={selectedCabang}
            handleAlertInfo={this.handleAlertInfoVisibility}
            handleLoading={this.handleTriggerLoading}
            onClickClose={() => this.handleDetailVisibility()}
          />
        )}
        {filterVisibility && (
          <MasterHargaJasaFilter
            visible={filterVisibility}
            submitedFilter={submitedFilter}
            handleSubmitFilter={this.handleSubmitFilter}
            onClickClose={this.handleFilterVisibility}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
        {alertInfo.visible && (
          <SimpleAlert
            visible={alertInfo.visible}
            title={alertInfo.title}
            content={alertInfo.content}
            onClickClose={() => this.handleAlertInfoVisibility()}
            additionalButtons={
              alertInfo.action === "submit" || alertInfo.action === "delete" ? (
                <FlexView style={{ gap: "15px" }}>
                  <SimpleButton
                    type="button"
                    text="Tidak"
                    onClick={() => this.handleAlertInfoVisibility()}
                  />
                  <SimpleButton
                    type="button"
                    text="Ya"
                    onClick={() => this.handleAccept()}
                  />
                </FlexView>
              ) : (
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertInfoVisibility()}
                />
              )
            }
          />
        )}
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(MasterHargaJasa);
